import React from 'react'
import { ICON_PATHS, IconName } from '@/presentation/constants/icon-paths'

type IconProps = {
  name: IconName
  size?: number
  strokeWidth?: number
  className?: string
  style?: React.CSSProperties
}

export const Icon: React.FC<IconProps> = ({
  name, size = 20, strokeWidth = 1.75, className = '', style,
}) => (
  <svg
    width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth={strokeWidth}
    strokeLinecap="round" strokeLinejoin="round"
    className={className} style={style}
    dangerouslySetInnerHTML={{ __html: ICON_PATHS[name] || '' }}
  />
)
